import { TaxonomyStatus } from '../../../enums/taxonomy-status.enum';
import { Range } from '../entities/range.model';


export class TaxonomyValue {
    constructor(
        public valueRange: Range,
        public statusRange: Range,
        public lastStatus: TaxonomyStatus,
        public value: string = '',
        public displayValue: string = '',
        public status: { message: string, value: TaxonomyStatus; } = { message: 'Ready to be submitted', value: TaxonomyStatus.New }) { }

    addValueChunk(value: string, displayValue?: string): void {
        this.value += value;
        this.displayValue += displayValue
            ? displayValue
            : value;
    }

    setStatus(value: TaxonomyStatus, message: string): void {
        this.status = {
            value: value,
            message: message
        };
    }
}
